<template>
	<im-table 
		v-if="!loading"	
		:loading="loading"
		:model="engines"
		:url="buildUrl"
		:layout="'prev, pager, next'"
		@getAll="getEngines"
		@delete="deleteRequest">
		<template slot="columns">
			<el-table-column
				prop="name"
				label="Nome" />
			<el-table-column
				prop="registrationNumber"
				label="Matricola" />
			<el-table-column
				prop="model"
				label="Veicolo" />
		</template>
	</im-table>
	<loading v-else />
</template>
<script>
import { TableColumn } from 'element-ui'
import { mapState, mapActions } from 'vuex'

export default{
	name: 'EnginesTable',
	components: {
		[TableColumn.name]: TableColumn,
	},
	computed: {
		...mapState({
			engines: state => state.engines.engines,
			loading: state => state.engines.loading
		}),
		siteId() {
			return this.$route.params.id ? this.$route.params.id : this.site.id
		}
	},
	created() {
		this.getAll(this.siteId);
	},
	methods: {
		...mapActions('engines', {
			getAll: 'getAll',
			delete: 'delete'
		}),
		getEngines(params) {
			this.getAll(this.siteId,params)
		},
		buildUrl(scope) {
			return `/sites/${this.siteId}/engines/${scope.row.id}`
		},
		deleteRequest(scope) {
			this.delete(scope.row.id)
		},
	},
}
</script>
<!-- 

<script>
	import { Table, TableColumn } from 'element-ui'
	import { mapState, mapActions } from 'vuex'

	export default{
		name: 'EnginesTable',
		computed: {
			...mapState({
				engines: state => state.engines.engines.docs,
				loading: state => state.engines.loading
			}),
			siteId() {
				return this.$route.params.id ? this.$route.params.id : this.site.id
			}
		},
		created () {
			this.getAll(this.siteId);
		},
		props: {
			site: Object
		},
	  	components: {
			[TableColumn.name]: TableColumn,
			[Table.name]: Table,
		},
		methods: {
			...mapActions('engines', {
			  getAll: 'getAll',
			  delete: 'delete'
			}),			deleteRequest(id) {
				this.delete({
					siteId: this.siteId,
					id
				})
			},
			nextRevision(revision) {
				return '10 di maggio'
			}
		},
	}
</script> -->